export default "__VITE_ASSET__d867da27__"